<div class="checkin">
	<i class="checkin__icon tagmeicon tagmeicon-close"></i>
	<img [src]="image[template]" />
	<p class="checkin__statement">{{ text[template] }}</p>
	<button class="checkin__btn checkin__btn--yes" (click)="handleYes()">Sim</button>
	<button class="checkin__btn checkin__btn--go-back" (click)="handleGoBack()">Voltar</button>
</div>
